import { ConsumerDataService } from './consumer-data.service';
import { ConsumerDataUIService } from './consumer-data-ui.service';

export const services = [ConsumerDataService, ConsumerDataUIService];

export * from './consumer-data.service';
export * from './consumer-data-ui.service';
